/**
 * @module gender
 * @description A list of gender
 */

export const gender = ['male', 'female', 'other'] as const;
export type Gender = (typeof gender)[number];
